var mySwiper1 = null
var mySwiper2 = null
var MainContent = document.getElementById('MainContent')
window.addEventListener('resize', () => {
  if (document.documentElement.clientWidth <= 860) {
    MainContent.style.zoom = (document.documentElement.clientWidth / 860).toFixed(2)
  } else {
    MainContent.style.zoom = 1
  }
})
if (document.documentElement.clientWidth <= 860) {
  let zoom = (document.documentElement.clientWidth / 860).toFixed(2)
  MainContent.style.zoom = zoom
}
setTimeout(() => {
  mySwiper1 = new Swiper('.customer-reviews-swiper', {
    freeMode: true,
    slidesPerView: 'auto',
    // spaceBetween: 33,
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.customer-reviews-next1',
      prevEl: '.customer-reviews-prev1',
      disabledClass: 'slide-arrow-disabled'
    }
  })
  mySwiper2 = new Swiper('.blog-swiper', {
    freeMode: true,
    slidesPerView: 'auto',
    // spaceBetween: 33,
    // 如果需要前进后退按钮
    navigation: {
      nextEl: '.blog-next1',
      prevEl: '.blog-prev1',
      disabledClass: 'slide-arrow-disabled'
    }
  })
}, 0)
